import { Injectable } from "@angular/core";
import { BehaviorSubject, Subject } from "rxjs";
import { IIndicator } from "../_models/indicator.vm";

@Injectable()
export class IndicatorService {

    private indicator: Subject<IIndicator> = new BehaviorSubject<IIndicator>(null);

    constructor() {}

    setIndicator(indicator: IIndicator) {
        this.indicator.next(indicator);
    }

    getIndicator() {
        return this.indicator.asObservable();
    }

}